export default "__VITE_ASSET__$ZVPyi7s__"